import httpClient from '../httpClient';

const sendMessage = payload => {
  return httpClient.post('ai/chat', payload);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  sendMessage,
};

